var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{staticClass:"left-line"}),_c('div',{staticClass:"title-text"},[_vm._v("施工企业资质业绩查询系统")]),_c('div',{staticClass:"right-line"})])
}]

export { render, staticRenderFns }